import { render } from "./VnRules.vue?vue&type=template&id=08f2c432&scoped=true"
import script from "./VnRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./VnRules.vue?vue&type=script&scoped=true&lang=js"

import "./VnRules.vue?vue&type=style&index=0&id=08f2c432&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08f2c432"

export default script